<template>
  <div class="kyvouchers">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li class="active"><a href="#">代金券</a></li>
          <li class="fr"><a href="#">代金券规则说明</a></li>
        </ul>
      </nav>
    </div>
    <p class="t-title" v-if="resource.length">
      <el-select v-model="value" placeholder="请选择" @change="selectChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </p>
    <p class="title" v-else>
      <a href="javascript:;">很抱歉,您还没有<span>未过期可用已用代金券</span></a>
    </p>
    <div class="items" v-if="resource.length">
      <ul>
        <li :class="'price'+item.price+' state'+item.state" v-for="(item,index) in resource" :key="`li${index}`">
          <span :class="'span'+item.lefttitle">
            {{item.text}}
          </span>
          <p class="price">￥{{item.amount}}</p>
          <p class="time">{{item.startDate}} 至 {{item.endDate}}</p>
          <p class="line"><i class="fl yd"></i><i class="fr yd"></i></p>
          <p class="num">
            代金券号: {{item.code}}
          </p>
        </li>
      </ul>
    </div>
    <div class="pages" v-if="resource.length">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        background
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'voucher',
  components: {
  },
  created () {
    if (this.$route.params.status) {
      this.$emit('topMenuStatus', this.$route.params.status)
    }
    this.loadresource(0)
  },
  data () {
    return {
      options: [
        {
          value: '0',
          label: '可用代金券'
        }, {
          value: '1',
          label: '过期代金券'
        }, {
          value: '2',
          label: '已使用代金券'
        }
      ],
      resource: [],
      currentPage: 1,
      pageSize: 6,
      total: 0,
      value: '0',
      status: '',
      expire: ''
    }
  },
  methods: {
    handleSizeChange (val) {
      console.log('当前页数发生改变')
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.loadresource(this.value)
    },
    selectChange(val) {
      this.currentPage = 1
      this.loadresource(val)
    },
    loadresource (type) {
      var queryParam = {
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }

      var status = 'status'
      var statusValue = ''
      var expire = 'expire'
      var expireValue = ''
      if (type === 0) {
        statusValue = 'n'
        queryParam[status] = statusValue
        expireValue = 'false'
        queryParam[expire] = expireValue
      }
      if (type === '1') {
        expireValue = 'true'
        queryParam[expire] = expireValue
      }
      if (type === '2') {
        statusValue = 'y'
        queryParam[status] = statusValue
      }

      this.sapost('/dmc/account/voucher', queryParam, r => {
        let {retCode, retMsg, pager} = r.data
        if (retCode === '0') {
          this.resource = []
          this.total = pager.total
          pager.list.forEach(voucher => {
            let item = voucher
            item.lefttitle = '0'
            item.price = Math.ceil(voucher.amount)
            if (voucher.status === 'n' && voucher.expire === false) {
              item.state = '0'
              if (voucher.expireWarm === true) {
                item.lefttitle = '1'
                item.text = '即将过期'
              }
            }
            if (voucher.expire === true) {
              item.state = '1'
              item.lefttitle = '1'
              item.text = '已过期'
            }
            if (voucher.status === 'y') {
              item.state = '2'
              item.lefttitle = '1'
              item.text = '已使用'
            }
            this.resource.push(item)
          })
          // this.resource = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    }
  }
}
</script>

<style lang="less">
.kyvouchers{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  min-height: 550px;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a{
            color:#b4b8bb;
          }
        }
        li.active,li:hover {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
        li.fr{
          float: right;
          margin-right: 15px;
          a {
            color: #333;
          }
        }
      }
    }
  }
  .t-title{
    margin: 10px 0px 25px;
    background-color: #eeeeee;
    .el-input--suffix .el-input__inner {
      padding-right: 30px;
      background-color: #eee;
      border: none;
    }
  }
  .title{
    margin-top: 125px;
    text-align: center;
    a{
      display: inline-block;
      line-height: 45px;
      height: 45px;
      padding: 0 85px;
      border-radius: 22.5px;
      color: #333;
      font-size: 18px;
      border: 2px solid #eee;
      span{
        color:#1353a5;
      }
    }
  }
  .items{
    overflow: hidden;
    ul{
      overflow: hidden;
      width: 900px;
      li{
        float: left;
        width: 270px;
        margin-right: 30px;
        height: 200px;
        border-radius: 6px;
        background-color: #c7c7c7;
        color: #fff;
        margin-bottom: 20px;
        position: relative;
        text-align: center;
        overflow: hidden;
        .span0{
          display: none;
        }
        .span1{
          background-color:#dcdcdc;
          padding: 30px 20px 0px;
          color:  #808080;
          position: absolute;
          left: -34px;
          top: -12px;
          font-size: 12px;
          font-weight: bold;
          transform: rotate(-45deg);
        }
        .price{
          font-size: 28px;
          margin: 45px 0px 35px;
        }
        .time {
          font-size: 12px;
          padding-bottom: 5px;
        }
        .line{
          border-bottom: 1px dotted #fff;
          position: relative;
          margin: 10px 0px;
          .yd{
            display: inline-block;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            position: absolute;
            background-color: #fff;
            top:-5px;
          }
          .fl{
            left: -4px;
          }
          .fr{
            right: -4px;
          }
        }
        .num{
          font-size: 12px;
          padding-top: 3px;
        }
      }
      li.price10000{
        background-color: #73c7d4;
        color: #fff;
        .span1{
          background-color:#ffd800;
          color:  #9b8200;
        }
      }
      li.price1000{
        background-color: #7ea6ce;
      }
      li.price100{
        background-color: #fb9999;
      }
      li.price50{
        background-color: #986d42;
      }
      li.price20{
        background-color: #a6cd3e;
      }
      /* 颜色设置一定要放在这之前 */
      li.state1,li.state2{
        background-color: #c7c7c7;
        .span1{
          background-color:#dcdcdc;
          color:  #808080;
          left: -29px;
          top: -14px
        }
      }
    }
  }
  .pages{
    margin-top: 55px;
    text-align: right;
    padding-top: 15px;
    padding-bottom: 45px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vouchers/availablevouchers.vue